<template>
  <div>
    <v-dialog persistent maxWidth="800" :value="value">
      <v-card>
        <v-card-title>
          {{ type == 'add' ? 'ADD' : 'EDIT' }} PRODUCT BUNDLED
          <v-spacer />
          <v-btn icon @click="handleCancelManageBundle" :loading="loading">
            <v-icon> close </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-layout>
            <v-flex shrink class="pr-2 pt-3"><strong>ชื่อโปรโมชั่น</strong></v-flex>
            <v-flex>
              <v-text-field
                class="default-input"
                outline
                name="name"
                v-model="currentBundle.name"
                single-line
                placeholder="ชื่อโปรโมชั่น"
                clearable
                @click:clear="currentBundle.name = ''"
                style="max-width: 300px"
                counter="20"
                dense
                persistent-hint
                hint="ชื่อโปรโมชั่นนี้จะไม่แสดงให้ผู้ซื้อเห็น"
                v-validate="'required'"
                :error="errors.has('name')"
                :error-messages="errors.first('name')"
              />
            </v-flex>
          </v-layout>

          <div class="mt-2"><strong>ประเภทโปรโมชั่น</strong></div>
          <div class="mt-2">จำนวนส่วนลด</div>
          <v-layout wrap>
            <v-layout xs12 sm6>
              <v-flex class="mt-3" shrink> จำนวน </v-flex>
              <v-flex class="pa-1">
                <v-text-field
                  class="default-input"
                  outline
                  name="quantity_condition"
                  v-model="currentBundle.quantity_condition"
                  single-line
                  placeholder="จำนวน"
                  clearable
                  @click:clear="currentBundle.quantity_condition = ''"
                  @blur="$set(currentBundle, 'quantity_condition', numberOnly($event))"
                  v-validate="'required'"
                  :error="errors.has('quantity_condition')"
                  :error-messages="errors.first('quantity_condition')"
                  dense
                />
              </v-flex>
              <v-flex class="mt-3"> ชิ้น </v-flex>
            </v-layout>
            <v-layout xs12 sm6>
              <v-flex class="mt-3" shrink> ลด </v-flex>
              <v-flex class="pa-1">
                <v-text-field
                  class="default-input"
                  outline
                  name="discount"
                  v-model="currentBundle.discount"
                  single-line
                  placeholder="ลด"
                  clearable
                  @click:clear="currentBundle.discount = ''"
                  dense
                  @blur="$set(currentBundle, 'discount', decimalOnly($event))"
                  v-validate="'required'"
                  :error="errors.has('discount')"
                  :error-messages="errors.first('discount')"
                />
              </v-flex>
              <v-flex class="mt-3"> ฿ </v-flex>
            </v-layout>
          </v-layout>

          <div class="mt-2"><strong>ระยะเวลาโปรโมชั่น</strong></div>
          ตั้งวันเวลาเปิด
          <v-layout>
            <v-flex class="pa-1">
              <DatepickerCustomDialog v-model="currentBundle.effective_date">
                <template v-slot="{ computedDate }">
                  <v-text-field
                    class="default-input"
                    outline
                    name="effective_date"
                    :placeholder="$t('Start date')"
                    readonly
                    :value="computedDate"
                    hide-details
                    single-line
                    clearable
                    @click:clear="currentBundle.effective_date = undefined"
                  ></v-text-field>
                </template>
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex class="pa-1">
              <CustomTimepicker
                name="starttime"
                :data-vv-as="'Start time'"
                :value="currentBundle.effective_time"
                @onChange="
                  (val) => {
                    currentBundle.effective_time = val
                  }
                "
                overlay
                format="HH:mm"
                placeholder="HH:mm"
                onlyTime
                clearable
              >
              </CustomTimepicker>
            </v-flex>
          </v-layout>
          ตั้งวันเวลาปิด
          <v-layout>
            <v-flex class="pa-1">
              <DatepickerCustomDialog v-model="currentBundle.end_date">
                <template v-slot="{ computedDate }">
                  <v-text-field
                    class="default-input"
                    outline
                    name="end_date"
                    :placeholder="$t('End date')"
                    readonly
                    :value="computedDate"
                    hide-details
                    single-line
                    clearable
                    @click:clear="currentBundle.end_date = undefined"
                  ></v-text-field>
                </template>
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex class="pa-1">
              <CustomTimepicker
                name="starttime"
                :data-vv-as="'Start time'"
                :value="currentBundle.end_time"
                @onChange="
                  (val) => {
                    currentBundle.end_time = val
                  }
                "
                overlay
                format="HH:mm"
                placeholder="HH:mm"
                onlyTime
                clearable
              >
              </CustomTimepicker>
            </v-flex>
          </v-layout>
          <div class="mt-2"><strong>จำนวนการใช้สิทธิ์ส่วนลด (ถ้ามี)</strong></div>
          <v-text-field
            class="default-input"
            outline
            name="limit"
            v-model="currentBundle.limit"
            hide-details
            single-line
            placeholder="จำนวนการใช้สิทธิ์ส่วนลด"
            clearable
            append-icon="limit"
            @click:clear="currentBundle.limit = ''"
            @blur="$set(currentBundle, 'limit', numberOnly($event))"
            style="max-width: 300px"
            dense
          />
        </v-card-text>
        <v-divider />
        <v-card-text>
          <v-layout>
            <v-flex><strong>สินค้าในโปรโมชั่น</strong></v-flex>
            <v-flex class="text-xs-right">
              <v-btn depressed color="primary" @click="showProductInBundle = true">
                <v-icon>add</v-icon>เพิ่ม
              </v-btn>
              <v-btn outline @click="handleRemoveAllProducts">ลบทั้งหมด</v-btn>
            </v-flex>
          </v-layout>

          <v-data-table
            :headers="bundleProductHeaders"
            :items="currentBundle.products"
            class="elevation-0"
            :pagination.sync="pagination"
            hide-actions
          >
            <template v-slot:items="props">
              <tr>
                <td>
                  <v-layout>
                    <v-flex shrink class="pa-2">{{ props.index + 1 }}</v-flex>
                    <v-flex shrink class="pa-1">
                      <img
                        :src="
                          props.item.photourl.length
                            ? props.item.photourl[0]
                            : '/static/img/assets/_global/default-photo.png'
                        "
                        :alt="`bundle_${props.index + 1}`"
                        style="width: 50px"
                      />
                    </v-flex>
                    <v-flex class="pa-2">{{ props.item.name }}</v-flex>
                  </v-layout>
                </td>
                <td class="text-xs-center">{{ props.item.price || 0 }}</td>
                <td class="text-xs-center">{{ props.item.quantity || 0 }}</td>
                <td class="text-xs-center">
                  <v-btn @click="handleRemoveProduct(props.item.id)" flat color="primary" icon>
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template></v-data-table
          >

          <input
            type="hidden"
            v-model="currentBundle.products"
            v-validate="'required'"
            name="products"
            data-vv-as="สินค้าในโปรโมชั่น"
          />
          <div class="red--text caption">
            {{ errors.has('products') ? errors.first('products') : '' }}
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="handleCancelManageBundle" :loading="loading">{{
            $t('cancel')
          }}</v-btn>
          <v-btn color="primary" depressed @click="handleSaveManageBundle" :loading="loading">{{
            $t('Save')
          }}</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template v-if="showProductInBundle">
      <ManageProductInBundle
        v-model="showProductInBundle"
        :products="currentBundle.products"
        :bundle="currentBundle"
        @handleSaveManageProductInBundle="handleSaveManageProductInBundle"
      />
    </template>
  </div>
</template>

<script>
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker2.vue'
import moment from 'moment'
import ManageProductInBundle from './ManageProductInBundle'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: {
    value: {
      default: false
    },
    bundle: {
      default: undefined
    },
    type: {
      default: 'add'
    }
  },
  components: {
    CustomTimepicker,
    DatepickerCustomDialog,
    ManageProductInBundle
  },
  data() {
    return {
      loading: false,
      showProductInBundle: false,
      currentBundle: {
        name: '',
        quantity_condition: null,
        discount: null,
        effective_date: '',
        effective_time: null,
        end_date: '',
        end_time: null,
        limits: null,
        status: true,
        timestamp: '',
        is_active: true,
        products: []
      },
      pagination: { rowsPerPage: -1 },
      bundleProductHeaders: [
        { text: 'รายการสินค้า', value: 'name' },
        { text: 'ราคา', value: 'price', align: 'center' },
        { text: 'จำนวนสินค้า', value: 'quantity', align: 'center' },
        { text: '', sortable: false }
      ]
    }
  },
  mounted() {
    if (this.bundle) {
      this.currentBundle = cloneDeep(this.bundle)
      this.$set(
        this.currentBundle,
        'effective_time',
        this.bundle.effective_date ? moment(this.bundle.effective_date).format('HH:mm') : null
      )
      this.$set(
        this.currentBundle,
        'end_time',
        this.bundle.end_date ? moment(this.bundle.end_date).format('HH:mm') : null
      )
    }
  },
  methods: {
    handleRemoveProduct(id) {
      const index = this.currentBundle.products.findIndex((product) => {
        return product.id == id
      })
      if (index != -1) {
        this.currentBundle.products.splice(index, 1)
      }
    },
    handleSaveManageProductInBundle(products) {
      this.$set(this.currentBundle, 'products', products)
    },
    handleCancelManageBundle() {
      this.$emit('input', false)
    },
    async handleSaveManageBundle() {
      const result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loading = true
      this.$emit('handleSaveManageBundle', {
        data: {
          ...this.currentBundle,
          effective_date: this.currentBundle.effective_date
            ? `${moment(this.currentBundle.effective_date).format('YYYY-MM-DD')} ${
                this.currentBundle.effective_time || '00:00'
              }`
            : null,
          end_date: this.currentBundle.end_date
            ? `${moment(this.currentBundle.end_date).format('YYYY-MM-DD')} ${
                this.currentBundle.end_time || '23:59'
              }`
            : null
        },
        onComplete: () => {
          this.$emit('input', false)
          this.loading = false
        }
      })
    },
    async handleRemoveAllProducts() {
      const result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        this.$set(this.currentBundle, 'products', [])
        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Bundles/ManageBundle.vue